<template>
  <div class="float_button">
    <div
      ref="floatButton"
      class="back"
      @click="back()"
      v-if="showBack == 'true'"
      :style="{
        width: itemWidth + 'px',
        margin: '5px 10px',
        height: itemHeight + 'px',
        left: left + 'px',
        top: top + 'px',
      }"
    >
      <img src="@/assets/images/back-icon.png" class="backImg" />
    </div>
  </div>
</template>
<script>
import { getStorage, getAppIdStorage, setAppIdStorage } from "../libs/storage"
import { getUserSubscribe } from "@/utils/api"
import { mapGetters } from "vuex"
export default {
  props: {
    isflag: {
      type: Boolean,
      default: false,
    },
    showBack: {
      type: String,
      default: "true",
    },
    ident: {
      type: String,
      default: "",
    },
    pageName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      clientWidth: 0,
      clientHeight: 0,
      timer: null,
      currentTop: 0,
      left: 0,
      top: 0,
      itemWidth: 32, //按钮宽度
      isShort: true,
      itemHeight: 32, // 悬浮按钮高度
      gapWidth: 0, // 距离左右两边距离
      coefficientHeight: 0, // 从上到下距离比例
    }
  },
  computed: {
    // ...mapGetters(['showBack']),
  },
  created() {
    let type = navigator.userAgent
    this.clientWidth = document.documentElement.clientWidth
    this.clientHeight = document.documentElement.clientHeight
  },
  mounted() {
    if (this.showBack === "true") {
      this.$nextTick(() => {
        const floatButton = this.$refs.floatButton
        floatButton.addEventListener("touchstart", () => {
          floatButton.style.transition = "none"
        })

        // 在拖拽的过程中，组件应该跟随手指的移动而移动。
        floatButton.addEventListener("touchmove", (e) => {
          if (e.targetTouches.length === 1) {
            // 一根手指
            let touch = e.targetTouches[0]
            this.left = touch.clientX - 20
            this.top = touch.clientY - 25
          }
        })

        // 拖拽结束以后，重新调整组件的位置并重新设置过度动画。
        floatButton.addEventListener("touchend", () => {
          floatButton.style.transition = "all 0.3s"
          if (this.left > document.documentElement.clientWidth / 2) {
            this.left =
              document.documentElement.clientWidth - this.itemWidth - 20
          } else {
            this.left = 0
          }
          if (this.top < 0) {
            this.top = 0
          }
          if (this.top > this.clientHeight - 110) {
            this.top = this.clientHeight - 110
          }
        })
      })
    }
  },
  methods: {
    back() {
      let appId = getStorage("appId")
      let infos_storage = getAppIdStorage(appId)
      //从商家小票跳转到订单详情
      if (this.pageName === "kfc") {
        window.location.href = "/kfc/order-list"
        return
      } else if (this.pageName === "mc") {
        window.location.href = "/mc/order-list"
        return
      } else if (this.pageName === "mallHome") {
        this.$router.replace("/parentCpn/welfare")
        return
      } else if (
        (this.pageName === "shop" && appId === "wxfcb34416b1538017") ||
        this.pageName === "local"
      ) {
        this.$router.replace("/local/home")
        return
      } else if (this.pageName === "shop") {
        this.$router.replace("/mall/home")
        return
      } else if (this.pageName === "mall") {
        window.location.href = "/parentCpn/welfare"
        return
      } else if (this.pageName === "member") {
        window.location.href = "/member"
        return
      } else if (this.pageName === "movie") {
        window.location.href = "/movie/home"
        return
      }

      if (infos_storage.subscribePage) {
        //获取用户是否关注公众号
        getUserSubscribe().then((res) => {
          if (res.data.code == 200) {
            // 是否关注：1-已关注，0-未关注
            let { data } = res.data
            if (data) {
              infos_storage.isSubscribe = "true"
            } else {
              infos_storage.isSubscribe = "false"
            }
            setAppIdStorage(appId, infos_storage)
          }
          this.$router.go(-1)
        })
        return
      }

      if (this.isflag) {
        window.location.href = "/parentCpn/welfare"
        return
      }

      //处理嵌套H5支付成功之后查看订单返回到对应H5页面
      if (infos_storage.tabName) {
        delete infos_storage.tabName
        setAppIdStorage(appId, infos_storage)
      }

      let environment = localStorage.getItem("environment")
      if (environment == "weixin") {
        if (window.history.length > 1) {
          if (window.history.state.back) {
            //解决通过电费分享进入到电费页面，当window.history.state.back为null是直接跳转首页
            if (window.history.state.back?.indexOf("/index") >= 0) {
              //如果上一个页面是Index页面，则直接返回首页
              if (appId === "wxfcb34416b1538017") {
                window.location.href = "/local/home"
              } else {
                window.location.href = "/parentCpn/welfare"
              }
            } else {
              window.history.go(-1)
            }
          } else {
            if (appId === "wxfcb34416b1538017") {
              window.location.href = "/local/home"
            } else {
              window.location.href = "/parentCpn/welfare"
            }
          }
        } else {
          if (appId === "wxfcb34416b1538017") {
            window.location.href = "/local/home"
          } else {
            window.location.href = "/parentCpn/welfare"
          }
        }
      } else {
        if (window.history.length > 1) {
          if (window.history.state.back) {
            if (window.history.state.back?.indexOf("/index") >= 0) {
              //如果上一个页面是Index页面，则直接返回首页
              if (appId === "wxfcb34416b1538017") {
                window.location.href = "/local/home"
              } else {
                window.location.href = "/parentCpn/welfare"
              }
            } else {
              if (
                window.history.state.back.indexOf("/parentCpn/classify") >= 0
              ) {
                //解决ios中 通过链接https://fl.bangkehui.com/parentCpn/classify或者公众号或者扫码进入页面，点击详情返回分类页面，选择左侧跳动问题
                window.location.href = "/parentCpn/classify"
              } else {
                this.$router.go(-1)
              }
            }
          } else {
            if (appId === "wxfcb34416b1538017") {
              window.location.href = "/local/home"
            } else {
              window.location.href = "/parentCpn/welfare"
            }
          }
        } else {
          if (appId === "wxfcb34416b1538017") {
            window.location.href = "/local/home"
          } else {
            window.location.href = "/parentCpn/welfare"
          }
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.back {
  width: 32px;
  height: 32px;
  position: fixed;
  left: 8px;
  top: 8px;
  opacity: 0.8;
  z-index: 999;
  touch-action: none;
  .backImg {
    width: 100%;
    height: 100%;
  }
}
</style>
